import { css } from 'emotion';

import { colors, fonts, icons } from '@cobliteam/base-components';

const idleEngineBadge = css`
  border-radius: 3px;
  padding: 6px 10px;
  background-color: ${colors.shadows.getShadow(colors.gray.dark, 0.1)};
  color: ${colors.gray.dark};

  & svg {
    margin-right: 10px;
    width: ${icons.size.smallest};
    height: ${icons.size.smallest};
  }

  > span {
    font-size: ${fonts.size.smallest};
    font-weight: ${fonts.weight.medium};
  }
`;

export default { idleEngineBadge };
